// extracted by css-extract-rspack-plugin
export default {"run-payroll-wrapper":"run-payroll-wrapper-oRkK52","runPayrollWrapper":"run-payroll-wrapper-oRkK52"};